import React from 'react'

import LegacyRetinaImage from 'components/LegacyRetinaImage'
import CardBack from 'images/inline/memory-match-card-back.svg'
import Check from 'images/inline/memory-match-check.svg'
import X from 'images/inline/memory-match-x.svg'
import './Card.scss'

const Card = ({
  cardsCount,
  disabled,
  frontImage,
  rearImage,
  cardId,
  onClick,
  isInactive,
  isFlipped,
}) => {
  const handleClick = () => {
    if (disabled || isInactive) {
      return
    }
    !isFlipped && onClick(cardId)
  }

  return (
    <div
      className={`memory-match-card flex-item 
      ${cardsCount === 8 || cardsCount === 16 ? '' : 'bigger-card'}
      ${isFlipped ? 'is-flipped' : ''} ${disabled ? 'is-disabled' : ''} ${
        isInactive ? 'is-inactive' : ''
      }`}
      onClick={handleClick}
    >
      <div className={`memory-match-card-inside`}>
        <div className="card-face card-front-face">
          {!!Object.keys(frontImage).length ? (
            <div className="card-back-image">
              <LegacyRetinaImage image={frontImage} />
            </div>
          ) : (
            <div className="default-card-back-image">
              <CardBack />
            </div>
          )}
        </div>
        <div className="card-face card-back-face">
          <LegacyRetinaImage image={rearImage} />
          <button className="checkmark-container" disabled={isInactive}>
            <div className="checkmark">
              <Check />
            </div>
          </button>
          <div className="x-container">
            <div className="x">
              {' '}
              <X />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Card
